import _styled, { css as _css, default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
import * as RadixAccordion from "@radix-ui/react-accordion";
import { useFragment, type FragmentType } from "~/gql/runtime";
import { hasItems } from "~/features/app/utils";
import { Icon } from "~/features/ui/icon";
import Minus from "~/public/icons/minus.svg";
import Plus from "~/public/icons/plus.svg";
import { fragment } from "~/features/app/app-footer/footer-links/footer-group";
import { FooterLink } from "~/features/app/app-footer/footer-links/footer-link";
type Props = FragmentType<typeof fragment> & {
  value: string;
  isOpen: boolean;
};
export function FooterGroupDropdown(props: Props) {
  const {
    value,
    isOpen,
    ...rest
  } = props;
  const {
    title,
    links
  } = useFragment(fragment, rest);
  if (!hasItems(links)) {
    return null;
  }
  return <RadixAccordion.Item value={value}>
      <RadixAccordion.Header>
        <_StyledRadixAccordionTrigger aria-label={title || undefined}>
          <_StyledSpan>{title}</_StyledSpan>
          <_StyledSpan2>
            <Icon icon={isOpen ? Minus : Plus} size="16" />
          </_StyledSpan2>
        </_StyledRadixAccordionTrigger>
      </RadixAccordion.Header>
      <_StyledRadixAccordionContent $_css2={[{
      "overflow": "hidden"
    }, _css(["@media (prefers-reduced-motion:no-preference){&[data-state=\"open\"]{", "}&[data-state=\"closed\"]{", "}}"], {
      "@keyframes radix-accordion-expand-keyframes": {
        "from": {
          "height": "0"
        },
        "to": {
          "height": "var(--radix-accordion-content-height)"
        }
      },
      "animation": "radix-accordion-expand-keyframes 250ms ease-in-out"
    }, {
      "@keyframes radix-accordion-collapse-keyframes": {
        "from": {
          "height": "var(--radix-accordion-content-height)"
        },
        "to": {
          "height": "0"
        }
      },
      "animation": "radix-accordion-collapse-keyframes 250ms ease-in-out"
    })]}>
        <_StyledUl>
          {links?.map((link, idx) => <li key={idx}>
              <FooterLink {...link} />
            </li>)}
        </_StyledUl>
      </_StyledRadixAccordionContent>
    </RadixAccordion.Item>;
}
var _StyledRadixAccordionTrigger = _styled(RadixAccordion.Trigger).withConfig({
  componentId: "sc-sf-f0iyud-0"
})({
  "display": "flex",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "space-between",
  "columnGap": "1.6rem",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "paddingTop": "2.4rem",
  "paddingBottom": "2.4rem",
  "textAlign": "left"
});
var _StyledSpan = _styled2("span").withConfig({
  componentId: "sc-sf-f0iyud-1"
})({
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.2rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.024rem",
  "fontWeight": "400",
  "color": "var(--text-transparent)"
});
var _StyledSpan2 = _styled3("span").withConfig({
  componentId: "sc-sf-f0iyud-2"
})({
  "display": "flex",
  "height": "2.4rem",
  "width": "2.4rem",
  "flexShrink": "0",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "2px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(108 112 97 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});
var _StyledRadixAccordionContent = _styled4(RadixAccordion.Content).withConfig({
  componentId: "sc-sf-f0iyud-3"
})`${p => p.$_css2}`;
var _StyledUl = /*#__PURE__*/_styled5("ul").withConfig({
  displayName: "footer-group-dropdown___StyledUl",
  componentId: "sc-1quvtxi-0"
})({
  "display": "flex",
  "flexDirection": "column",
  "rowGap": "2.4rem",
  "paddingLeft": "1.6rem",
  "paddingRight": "1.6rem",
  "paddingBottom": "2.4rem",
  "fontSize": "1.6rem",
  "lineHeight": "1.5",
  "fontWeight": "400"
});